// @react-functional

import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesBanner } from './components/banner/CookiesBanner';
import { acceptCookies } from './acceptCookies';
import { providerKeys, getCookiesPolicy } from './cookiesUtils';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { CommonAppProviders } from '../app/common-app/CommonAppProviders';

export interface PublicustomWindow extends Window {
  logged_in: boolean;
}
declare let window: PublicustomWindow;

function detectUserNavigationForOptIn(event: MouseEvent) {
  // user auto opt-in if he clicks on an hyperlink except for cookie edit page
  if (event.target instanceof HTMLAnchorElement) {
    let element = event.target;
    while (
      element &&
      element.nodeName &&
      element.nodeName.toLowerCase() !== 'a'
    ) {
      element = element.parentElement as HTMLAnchorElement;
    }
    const isNotEditCookieLink =
      element && element.href && element.href.indexOf('/cookies') === -1;
    if (element && isNotEditCookieLink) {
      acceptCookies();
      window.removeEventListener('click', detectUserNavigationForOptIn);
    }
  }
}

export function displayCookieBannerWhenNeeded() {
  const cookie = getCookiesPolicy();

  const noCookieYet = !cookie;
  const hasUnacceptedProvider =
    !!cookie && providerKeys.some(key => cookie[key] === null);
  if (noCookieYet || hasUnacceptedProvider) {
    const target: HTMLDivElement | null = document.querySelector(
      `[data-react=cookies-banner]`,
    );

    if (target) {
      doctrineAnalytics('Account CookieBannerShown');
      ReactDOM.render(
        <CommonAppProviders isLoggedIn={window.logged_in}>
          <CookiesBanner onValid={acceptCookies} />
        </CommonAppProviders>,
        target,
      );

      window.addEventListener('click', detectUserNavigationForOptIn);
    }
  }
  // temporary stop log rocket because of a potential impact on search
  /* if (cookie && cookie.logrocket_cookie) {
    startLogRocket();
  } */
}
